// extracted by mini-css-extract-plugin
module.exports = {"root":"Show-module__root___p_mfW","text":"Show-module__text___2q33p Fonts-module__bt___102gf","docs":"Show-module__docs___3-NOj","tutors":"Show-module__tutors___33SwN"};